import React from 'react';
import { Button, Input, Select, Switch  } from 'antd';
import { ArrowRightOutlined , ArrowLeftOutlined } from "@ant-design/icons";

const { Option } = Select;

const StepBenefitMechanic = ({ onNext, onBack, formData, updateField }) => {
  const giftEnabled = Boolean(formData.giftEnabled);
  const discountEnabled = Boolean(formData.discountEnabled);

  return (
    <div className='step-container'>
      <div className='step-content'>
        <div className='step-header'>          
          <div className='step-title'>Benefit & Mechanic</div>
          <div className='step-subtitle'>Choose how this rule rewards the customer.</div>
        </div>

        <div className='step-form'>
            
          <div className='step-group'>
            <div className='step-form-group-inner d-flex d-flex-row alignCenter gap-8'>
              <Switch
                checked={formData.giftEnabled}
                size="small"
                onChange={(checked) => updateField('giftEnabled', checked)}
              />
              <span className='step-switch-label'>Gift</span>
              </div>
              <div className='step-form-hint-dark'>
                List the GWP SKUs available for this rule.
              </div>
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Min Cart Value</div>
            <Input
              placeholder="150"
              value={formData.minCartValue}
              onChange={(e) => updateField('minCartValue', e.target.value)}
              className='Input-border InputText'
              disabled={!giftEnabled}
            />
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Gift SKUs</div>
            <Select
              mode="tags"
              tokenSeparators={[',', ' ']}
              placeholder="GIFT001, GIFT002, GIFT003"
              value={formData.giftSkus || []}
              onChange={(value) => updateField('giftSkus', value)}
              className='Input-border InputSelect w-100'
              style={{ width: '100%' }}
              disabled={!giftEnabled}
            />
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Gifts Per Order</div>
            <Select
              value={formData.giftsPerOrder}
              onChange={(value) => updateField('giftsPerOrder', value)}
              className='Input-border InputSelect w-100'
              disabled={!giftEnabled}
            >
              <Option value="2">2</Option>
              <Option value="1">1</Option>
              <Option value="3">3</Option>
            </Select>
            <div className='step-form-hint'>How many of the 5 SKUs above the customer receives — they choose 2.</div>
          </div>

          <div className='step-group'>
            <div className='step-form-group-inner d-flex d-flex-row alignCenter gap-8'>
              <Switch
                checked={formData.discountEnabled}
                size="small"
                onChange={(checked) => updateField('discountEnabled', checked)}
              />
              <span className='step-switch-label'>Discount</span>
            </div>
          </div>

          <div className='step-group d-flex d-flex-row gap-16'>
            <div className='w-50 step-group'>
              <div className='step-form-label'>Discount Type</div>
                <Select
                  value={formData.discountType}
                  onChange={(value) => updateField('discountType', value)}
                  className='Input-border InputSelect w-100'
                  disabled={!discountEnabled}
                >
                  <Option value="percentage">Percentage</Option>
                  <Option value="fixed">Fixed</Option>
                </Select>
            </div>
            <div className='w-50 step-group'>
              <div className='step-form-label'>Discount Value</div>
              <Input
                placeholder="e.g. 20 or 15.00"
                value={formData.discountValue}
                onChange={(e) => updateField('discountValue', e.target.value)}
                className='Input-border'
                disabled={!discountEnabled}
              />
            </div>
          </div>
        </div>

        <div className='step-footer'>
          <Button onClick={onBack} className='btn-s'>
            <ArrowLeftOutlined />
            Previous: Basic Info
          </Button>
          <Button type="primary" onClick={onNext} className='btn-p'>
            Next: Eligibility Conditions 
            <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepBenefitMechanic;
